import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Permission } from '@/models/Permission';

/**
 * Single source of truth for the clinical-permission code names and the
 * getters that check them, so the diagnosis / non-profile-medication gating
 * stays consistent across every screen that manages those records.
 */
export const ClinicalPermissionCodeNames = {
    manageDiagnoses: 'Patient Dashboard/Manage Diagnoses',
    manageNonProfileMedications: 'Patient Dashboard/Manage Non-Profile Medications',
} as const;

@Component
export default class ClinicalPermissionsMixin extends Vue {
    get canManageDiagnoses(): boolean {
        return this.$permissions.some(
            (p: Permission) => p.permissionCodeName === ClinicalPermissionCodeNames.manageDiagnoses
        );
    }

    get canManageNonProfileMeds(): boolean {
        return this.$permissions.some(
            (p: Permission) => p.permissionCodeName === ClinicalPermissionCodeNames.manageNonProfileMedications
        );
    }
}
